import { em } from "framer-motion/client";
import apiClient from "../helper/Axios/axiosHelper";
import logger from "../utils/logger";

export class MemberService {


  static async getMembers(data, param) {

    logger.info('getMember params: ', data, ' ', param)

    const members = await apiClient.get(`${param}`, param && {
      params: data,
      headers: {
        Accept: "application/json"
      }

    })

    logger.warn('members: ', members)

    return members
  }

  static async getMemberById(id) {

    const memberData = await apiClient.get(`Member/${id}`)

    logger.warn(`Member ID: ${id} data: `, memberData)

    return memberData
  }


  static async getMemberEnrollment(email) {



    const memberEnrollment = await apiClient.get(`Enrollment/${email}`)

    logger.debug('Member ENROLLMENT: ', memberEnrollment)

    return memberEnrollment
  }


  // static async dinamicEnrollmentAction(action, params, urlSegment) {

  //   logger.debug('action: ', action, ' params: ', params, 'urlSegment: ', urlSegment)

  //   if (urlSegment === 'Enrollment') {

  //     // if (params.hasOwnProperty('enrollmentId')) {
  //     if (this.isActionWithBody(action)) {
  //       const dinamicEnrollment = await apiClient.put(`${urlSegment}/${action}`, params)

  //       logger.debug('Member ENROLLMENT ACTION: ', dinamicEnrollment)

  //       return dinamicEnrollment
  //     }
  //     else {

  //       const dinamicEnrollment = await apiClient.put(`${urlSegment}/${action}?email=${params.email}`)

  //       logger.debug('Enrollment  ACTION: ', dinamicEnrollment)

  //       return dinamicEnrollment
  //     }
  //   } else if (urlSegment === 'TPATraining') {

  //     logger.debug('cae en TPATraining')

  //     const dinamicEnrollment = await apiClient.put(`${urlSegment}/${action}?email=${params.email}&enrollmentId=${params.enrollments[0].id}`)

  //     logger.debug('TPATraining  ACTION: ', dinamicEnrollment)

  //     return dinamicEnrollment
  //   }
  //   else if (urlSegment == 'Delivery') {
  //     logger.debug('cae en Delivery')

  //     const dinamicEnrollment = await apiClient.put(`${urlSegment}/${action}/${params.id}`)

  //     logger.debug('TPATraining  ACTION: ', dinamicEnrollment)

  //     return dinamicEnrollment
  //   }


  //   // const dinamicEnrollment = await apiClient.put(`${urlSegment}/${action}`, params)

  //   //   logger.debug('Member ENROLLMENT ACTION: ', dinamicEnrollment)

  //   //   return dinamicEnrollment




  // }



  static async dinamicEnrollmentAction(urlTarget, body, type) {

    logger.debug('urlTarget: ', urlTarget, ' body: ', body, 'type: ', type)


    if (type === 'param') {
      const dinamicEnrollment = await apiClient.put(urlTarget, body)
      
logger.debug('dinamicEnrollment response: ',dinamicEnrollment)

      return dinamicEnrollment

    }
    else if (type === 'query') {
      const dinamicEnrollment = await apiClient.put(urlTarget)
      
logger.debug('dinamicEnrollment response: ',dinamicEnrollment)

      return dinamicEnrollment

    }


  }



  static async TPATrainingChangeReachedState(email, state, enrollmentId) {

    logger.debug('ChangeReachedState data: ', email, state, enrollmentId)

    const response = await apiClient.put(`TPATraining/ChangeReachedState?email=${email}&newReachedState=${state}&enrollmentId=${enrollmentId}`)

    logger.warn('ReachedState response: ', response)


    return response
  }

  static async ChangeTPATrainingReachedState(email, enrollmentId, state) {

    logger.debug('ChangeReachedState data: ', email, state)

    const response = await apiClient.put(`TPATraining/ChangeReachedState?email=${email}&enrollmentId=${enrollmentId}&newReachedState=${state}`)

    logger.warn('ReachedState response: ', response)


    return response
  }


  static async ChangeReachedState(email, state) {

    logger.debug('ChangeReachedState data: ', email, state)

    const response = await apiClient.put(`Enrollment/ChangeReachedState?email=${email}&newReachedState=${state}`)

    logger.warn('ReachedState response: ', response)


    return response
  }

  static isActionWithBody(action) {

    const actionsWithBody = [

      'ResendInscriptionMail',
      'Reject',
      'Approve',

    ]

    return actionsWithBody.indexOf(action) >= 0
  }

}

